import excel from '../assests/file-thumbnails/excel.png'
import gif from '../assests/file-thumbnails/gif.png'
import json from '../assests/file-thumbnails/json.png'
import pdf from '../assests/file-thumbnails/pdf.png'
import ppt from '../assests/file-thumbnails/ppt.png'
import txt from '../assests/file-thumbnails/txt.png'
import xml from '../assests/file-thumbnails/xml.png'
import mp3 from '../assests/file-thumbnails/mp3.png'
import link from '../assests/file-thumbnails/link.png'

import otherFile from '../assests/file-thumbnails/other-file.png'

export function DynamicFileThumbnail(file, baseUrl) {

    let fileExtension = file.split('.').pop();

    switch (fileExtension?.toLowerCase()) {
        case 'gif':
        case 'jpeg':
        case 'png':
        case 'jpg':
            return `${baseUrl}/${file}`;

        case 'xls':
        case 'xlsx':
        case 'csv':
            return excel;

        case 'json':
            return json;

        case 'pdf':
            return pdf;

        case 'ppt':
        case 'pptx':
            return ppt;

        case 'txt':
        case 'doc':
        case 'docx':
            return txt;

        case 'xml':
            return xml;

        case 'mp3':
        case 'wav':
        case 'wma':
            return mp3;

        default:
            if (file.startsWith('https'))
                return link;
            return otherFile;
    }
}

export function checkLinkFileExtension(link) {
    if (link) {
        const extensions = [
            'gif',
            'jpeg',
            'png',
            'jpg',
            'xls',
            'xlsx',
            'csv',
            'json',
            'pdf',
            'ppt',
            'pptx',
            'txt',
            'doc',
            'docx',
            'xml',
            'mp3',
            'wav',
            'wma',];

        const fileExtension = link?.split('.').pop().toLowerCase();

        return extensions.some((extension) => fileExtension === extension.toLowerCase());
    }
    return false;
}